import { Popover } from 'antd'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'
import { WarningIcon } from 'screens/Rostering/RotaBuilder/common/components/icons'
import useClockInWarnings from 'screens/Rostering/hooks/useClockInWarnings'
import { useMemo } from 'react'
import { ClockInTeamMember } from 'screens/Rostering/types'

export type TypeWarningsProps = React.PropsWithChildren<{
  warnings?: string[]
}>

export const Warnings = ({ warnings, children }: TypeWarningsProps) => {
  const { t } = useTranslation()

  const warningsContent = useMemo(() => {
    return (
      !!warnings?.length && (
        <WarningContent>
          <WarningTitle level={2}>{t('WARNINGS')}</WarningTitle>
          {warnings.map((warning) => (
            <WarningItem key={warning}>
              <WarningIcon /> <span>{t(warning)}</span>
            </WarningItem>
          ))}
        </WarningContent>
      )
    )
  }, [warnings])

  return (
    <Popover
      placement="bottomRight"
      showArrow
      arrow={{ pointAtCenter: true }}
      trigger="hover"
      content={warningsContent}
    >
      <Content>
        {!warnings?.length ? null : (
          <WarningIconWrapper>
            <WarningIcon />
          </WarningIconWrapper>
        )}
        {children}
      </Content>
    </Popover>
  )
}

export type ClockInOutWarningsProps = {
  warnings: ClockInTeamMember['warnings']
}

export const ClockInOutWarnings = ({ warnings }: ClockInOutWarningsProps) => {
  const clockInWarnings = useClockInWarnings(warnings)

  if (clockInWarnings.length === 0) return null

  return <Warnings warnings={clockInWarnings} />
}

const WarningContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const WarningTitle = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color5};
`

const WarningItem = styled.div`
  display: inline-flex;
  gap: 4px;
  align-items: center;
`

const WarningIconWrapper = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
`

const Content = styled.div`
  display: inline-flex;
  gap: 4px;
`
